import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const exportToExcel = (jsonData, fileName, styling = null) => {
  // Create a new worksheet from JSON data
  const worksheet = XLSX.utils.json_to_sheet(jsonData);
  if(styling) {
    worksheet["!cols"] = [
      styling
    ];
  }
  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Write the workbook and convert it to a Blob
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const excelFile = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

  // Trigger file download
  saveAs(excelFile, `${fileName}.xlsx`);
};
export default exportToExcel;

export const dataToCsv = (targetRef) => {
  if(!targetRef) {
    alert("cannot find targetRef")
    return
  }
  const csvContent = targetRef.current.getDataAsCsv();
  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "export.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
